const ERROR_TYPE_MAP: Record<string, string> = {
  SyntaxError: '语法错误',
  IndentationError: '缩进错误',
  TabError: 'Tab与空格混用错误',
  NameError: '名称错误',
  TypeError: '类型错误',
  ValueError: '值错误',
  IndexError: '索引错误',
  KeyError: '键错误',
  AttributeError: '属性错误',
  ZeroDivisionError: '除零错误',
  FileNotFoundError: '文件未找到',
  ImportError: '导入错误',
  ModuleNotFoundError: '模块未找到',
  RuntimeError: '运行时错误',
  RecursionError: '递归深度超限',
  OverflowError: '溢出错误',
  MemoryError: '内存不足',
  StopIteration: '迭代结束',
  AssertionError: '断言失败',
  UnboundLocalError: '局部变量未绑定',
  NotImplementedError: '未实现的功能',
  OSError: '系统错误',
  TimeoutError: '超时错误',
  ConnectionError: '连接错误',
  UnicodeError: '编码错误',
  EOFError: '输入结束',
  KeyboardInterrupt: '程序被中断',
};

const ERROR_DESC_MAP: Record<string, string> = {
  'invalid syntax': '无效的语法',
  'unexpected indent': '不期望的缩进',
  'expected an indented block': '期望一个缩进块',
  'unindent does not match any outer indentation level': '缩进不匹配',
  'list index out of range': '列表索引超出范围',
  'division by zero': '除以零',
  'cannot assign to literal': '不能赋值给常量',
  'invalid character': '无效字符',
  'unsupported operand type(s)': '不支持的操作类型',
  'EOL while scanning string literal': '字符串未闭合',
  'missing parentheses in call to \'print\'': 'print 缺少括号（请使用 print()）',
  'string index out of range': '字符串索引超出范围',
  'tuple index out of range': '元组索引超出范围',
  'int object is not subscriptable': '整数不能使用索引访问',
  'str object is not callable': '字符串不能被调用',
  'int object is not iterable': '整数不能被迭代',
  'float object is not iterable': '浮点数不能被迭代',
  'NoneType object is not iterable': 'None 不能被迭代',
  'NoneType object has no attribute': 'None 没有该属性',
  'object is not subscriptable': '对象不能使用索引访问',
  'object is not callable': '对象不能被调用',
  'object is not iterable': '对象不能被迭代',
  'object has no attribute': '对象没有该属性',
  'not enough arguments': '参数不足',
  'too many arguments': '参数过多',
  'takes exactly': '需要恰好',
  'takes no arguments': '不接受参数',
  'takes at least': '至少需要',
  'takes at most': '最多接受',
  'got an unexpected keyword argument': '收到意外的关键字参数',
  'missing required positional argument': '缺少必要的位置参数',
  'maximum recursion depth exceeded': '递归深度超限',
  'cannot unpack non-iterable': '无法解包非迭代对象',
  'too many values to unpack': '值过多无法解包',
  'not enough values to unpack': '值不足无法解包',
  'argument must be a string': '参数必须是字符串',
  'argument must be an integer': '参数必须是整数',
  'math domain error': '数学域错误',
  'could not convert string to float': '无法将字符串转换为浮点数',
  'invalid literal for int': '无效的整数字面值',
  'is not defined': '未定义',
  'No module named': '没有名为',
  'cannot import name': '无法导入名称',
  'relative import with no known parent package': '相对导入没有已知父包',
};

export function adjustErrorLineNumbers(
  errorText: string,
  lineOffset: number
): string {
  if (!errorText || lineOffset === 0) return errorText;

  return errorText.replace(
    /line (\d+)/g,
    (match, lineNum) => {
      const adjusted = parseInt(lineNum, 10) - lineOffset;
      if (adjusted <= 0) return match;
      return `line ${adjusted}`;
    }
  );
}

export function translateErrorToChinese(
  errorText: string,
  lineOffset: number = 0
): string {
  if (!errorText) return errorText;

  let text = errorText;

  text = text.replace(
    /line (\d+)/g,
    (match, lineNum) => {
      const originalLine = parseInt(lineNum, 10);
      const adjusted = lineOffset > 0 ? originalLine - lineOffset : originalLine;
      if (adjusted <= 0) return match;
      return `第 ${adjusted} 行`;
    }
  );

  for (const [engType, cnType] of Object.entries(ERROR_TYPE_MAP)) {
    text = text.replace(new RegExp(`^${engType}:`, 'g'), `${cnType}:`);
  }

  const sortedDescs = Object.entries(ERROR_DESC_MAP).sort(
    (a, b) => b[0].length - a[0].length
  );
  for (const [engDesc, cnDesc] of sortedDescs) {
    text = text.replace(new RegExp(engDesc, 'gi'), cnDesc);
  }

  return text;
}

export function getInputLineOffset(hasInput: boolean): number {
  return hasInput ? 3 : 0;
}